<template>
  <div
    v-if="show"
    class="FormAlert"
    :class="{
      'FormAlert--Success': isSuccess,
      'FormAlert--Error': isError,
      'FormAlert--Info': isInfo
    }"
  >
    <div class="flex items-center">
      <div>
        <aw-icon
          v-if="isSuccess"
          icon="check"
          class="w-6 h-6 text-white "
        />
        <aw-icon
          v-if="isError"
          icon="error"
          class="w-6 h-6 text-white "
        />
        <aw-icon
          v-if="isInfo"
          icon="info"
          class="w-6 h-6 text-white "
        />
      </div>
      <div class="px-4 flex-grow">
        <div class="text-sm text-white">
          <slot></slot>
        </div>
      </div>
      <div v-if="allowClose">
        <aw-icon
          @click="close()"
          icon="close"
          class="w-5 h-5 text-white cursor-pointer"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    alert: String,
    allowClose: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      show: true
    }
  },
  computed: {
    isError() {
      return this.alert === 'error'
    },
    isSuccess() {
      return this.alert === 'success'
    },
    isInfo() {
      return this.alert === 'info'
    }
  },
  methods: {
    close() {
      this.show = false
    }
  },
}
</script>
